import base from '../base/base';
import header from '../base/header';

import TopVideoPlayer from '../../components/platformPlayer/TopVideoPlayer';
import SectionFrontVideoLoader from '../../components/platformPlayer/SectionFrontVideoLoader';
import MlbamPlayer from '../../components/mlbamPlayer/MlbamMenuHandler.js'

new TopVideoPlayer();
new SectionFrontVideoLoader();
new MlbamPlayer();


// WEBPACK FOOTER //
// ./assets/layouts/section-front/section-front.js